<template>
  <i
    class="tm-overlay-span"
    @mouseenter="$_onHoverOverlay"
    @mouseleave="$_onHoverOverlay"
  >
    <i class="tm-overlay-material" :style="styleObj" />

    <tm-overlay-sprite
      :style="styleObj"
      :overlay="$props.overlay"
      :rectangle="$props.rectangle"
      :showDim="showDim"
      :isSelected="isSelected"
    />

    <tm-overlay-expired
      :style="styleObj"
      :overlay="$props.overlay"
      :rectangle="$props.rectangle"
      :isFirst="$props.isFirst"
      :isBanner="isLongest"
    />

    <tm-overlay-badge
      v-if="showBadge"
      :style="styleObj"
      :duration="$props.overlay.displayDuration"
    />

    <tm-overlay-border
      :style="styleObj"
      :isFirst="$props.isFirst"
      :isLast="$props.isLast"
      :borderMode="$props.borderMode"
      :rectangle="$props.rectangle"
    />
  </i>
</template>

<script>
import { mapState } from 'vuex';
import tmOverlaySprite from './tmOverlaySprite.vue';
import tmOverlayExpired from './inlay/tmOverlayExpired.vue';
import tmOverlayBadge from './tmOverlayBadge.vue';
import tmOverlayBorder from './tmOverlayBorder.vue';

export default {
  name: 'tm-overlay-span',
  components: {
    tmOverlaySprite,
    tmOverlayExpired,
    tmOverlayBadge,
    tmOverlayBorder,
  },

  props: {
    rectangle: { type: Object, required: true },
    isFirst: { type: Boolean, required: true },
    isLast: { type: Boolean, required: true },
    overlay: { type: Object, required: true },
    isHovered: { type: Boolean, required: true },
    isSceneEdit: { type: Boolean, required: true },
    isSelected: { type: Boolean, required: true },
    borderMode: { type: String, required: true },
  },

  computed: {
    ...mapState('timemachine', {
      pxOverlayTopOffset: (state) => state.cssVariables.pxOverlayTopOffset,
      pxOverlayH: (state) => state.cssVariables.pxOverlayH,
    }),

    styleObj() {
      return {
        transform: `translate3d(${this.$props.rectangle.p1.x}px, ${
          this.$props.rectangle.p1.y + this.pxOverlayTopOffset
        }px, 0)`,
        width: `${this.$props.rectangle.width}px`,
        height: `${this.pxOverlayH}px`,
      };
    },

    showBadge() {
      return this.$props.isSceneEdit && this.$props.isFirst;
    },

    showDim() {
      return this.$props.isHovered;
    },

    isLongest() {
      return this.$props.rectangle.isLongest;
    },
  },

  methods: {
    $_onHoverOverlay(e) {
      this.$emit(
        'hoveredOverlay',
        e.type === 'mouseenter',
        this.$props.rectangle
      );
    },
  },
};
</script>

<style lang="scss">
.tm-overlay > .tm-overlay-span {
  .tm-overlay-material {
    position: absolute;
    top: 0;
  }
}
</style>
